var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FieldsetModel',{attrs:{"ui":_vm.uiBaseFieldset,"name":_vm.fieldsetNameComp,"ui-title":_vm.title,"ui-subtitle":_vm.subtitle,"ui-columns":_vm.columns}},[_c('UiWrapper',{attrs:{"name":_vm.FIELD_NAMES.firstName,"label":_vm.firstNameLabel,"default-value":_vm.getValueFromCookie('nbc', 'firstName'),"validations":[
        {
          'errorMessage': 'Field contains invalid characters',
          'condition': _vm.patternCondition(_vm.NAMES_CHARS),
          'name': 'name-chars',
        } ]}},[_c('InputText')],1),_c('UiWrapper',{attrs:{"name":_vm.FIELD_NAMES.lastName,"label":_vm.lastNameLabel,"validations":[
        {
          'errorMessage': 'Field contains invalid characters',
          'condition': _vm.patternCondition(_vm.NAMES_CHARS),
          'name': 'lastname-chars',
        } ]}},[_c('InputText')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }